// Helper to append the vue-apollo `subcribeToMore` option, to a given vue-apollo query options object. It applies all apollo options passed for query and subscription.
// The reason to use both query and subscriptions instead of only subscriptions is that subscription results are not cached.
function queryWithSubscription(propertyName, options) {
	const subscription = JSON.parse(JSON.stringify(options.query).replace(/query/g, 'subscription')) // should be safe, as GQL is JSON

	return {
		...options,
		subscribeToMore: {
			document: subscription,
			updateQuery(previousResult, {subscriptionData}) {
				return {
					[propertyName]: subscriptionData.data[propertyName],
				}
			},
			...{...options, query: null},
		},
	}
}

export default queryWithSubscription

/*
explanatory example:

	transforms:

		{
			query: queryUserSessions,
			context() {
				return {
					headers: {'X-Hasura-Session-Id': '1'},
				}
			},
			variables() {
				return {workspaceId: this.$store.workspace.id}
			},
		}

	to:

		{
			query: queryUserSessions,
			context() {
				return {
					headers: {'X-Hasura-Session-Id': '1'},
				}
			},
			variables() {
				return {workspaceId: this.$store.workspace.id}
			},
			subscribeToMore: {
				document: sessionsSubscription,
				context() {
					return {
						headers: {'X-Hasura-Session-Id': '1'},
					}
				},
				variables() {
					return {workspaceId: this.$store.workspace.id}
				},
				updateQuery(previousResult, {subscriptionData}) {
					return {
						userSessionsList: subscriptionData.data.userSessionsList,
					}
				},
			},
		}
*/
